// extracted by mini-css-extract-plugin
export default {"formInput":"FormFieldModal_formInput__No56d","dangerZone":"FormFieldModal_dangerZone__CRQdE","removeButton":"FormFieldModal_removeButton__Gk2wQ"};